import ColorLensIcon from '@mui/icons-material/ColorLens';
import TextFieldsIcon from '@mui/icons-material/TextFields';

import { LocalizationsLink, LocalizationsNewLink, ThemesLink } from 'constants/routerPath';

import type { MenuGroup } from './types';

const content: MenuGroup = {
    id: 'group-content',
    title: 'Content',
    type: 'group',
    children: [
        {
            id: 'localization',
            title: 'Localizations',
            type: 'item',
            url: LocalizationsLink,
            icon: TextFieldsIcon,
            breadcrumbs: false,
            permission_name: 'localization',
        },
        {
            id: 'localization-new',
            title: 'Localizations (New)',
            type: 'item',
            url: LocalizationsNewLink,
            icon: TextFieldsIcon,
            breadcrumbs: false,
            permission_name: 'localization-new',
        },
        {
            id: 'theme',
            title: 'Themes',
            type: 'item',
            url: ThemesLink,
            icon: ColorLensIcon,
            breadcrumbs: false,
            permission_name: 'themes',
        },
    ],
};

export default content;
